// NOTICE: KAPTION-INTEGRATION
// whatsapp-calling.EVENTS.1..4 — ActionCable event names. helper/actionCable.js
// re-emits each one on the mitt bus untouched; the call store listens here.
// The mock layer emits on the same bus, so it exercises this exact path.
import { emitter as defaultEmitter } from 'shared/helpers/mitt';

export const CALL_EVENTS = Object.freeze({
  RINGING: 'kaption_call.ringing',
  ANSWERED: 'kaption_call.answered',
  UPDATED: 'kaption_call.updated',
  ENDED: 'kaption_call.ended',
  AVAILABILITY_CHANGED: 'kaption_call.availability_changed',
  // whatsapp-calling-ownership.PASS.9, LINE.3
  PASS_RINGING: 'kaption_call.pass_ringing',
  PASS_FAILED: 'kaption_call.pass_failed',
  PASSED: 'kaption_call.passed',
  LINE_CHANGED: 'kaption_call.line_changed',
  // whatsapp-call-transcripts.EVENTS.2
  TRANSCRIPT_UPDATED: 'kaption_call.transcript_updated',
});

export const subscribeKaptionCallEvents = (store, emitter = defaultEmitter) => {
  const handlers = {
    [CALL_EVENTS.RINGING]: store.onRinging,
    [CALL_EVENTS.ANSWERED]: store.onAnswered,
    [CALL_EVENTS.UPDATED]: store.onUpdated,
    [CALL_EVENTS.ENDED]: store.onEnded,
    [CALL_EVENTS.AVAILABILITY_CHANGED]: store.onAvailabilityChanged,
    [CALL_EVENTS.PASS_RINGING]: store.onPassRinging,
    [CALL_EVENTS.PASS_FAILED]: store.onPassFailed,
    [CALL_EVENTS.PASSED]: store.onPassed,
    [CALL_EVENTS.LINE_CHANGED]: store.onLineChanged,
    [CALL_EVENTS.TRANSCRIPT_UPDATED]: store.onTranscriptUpdated,
  };
  Object.entries(handlers).forEach(([event, handler]) =>
    emitter.on(event, handler)
  );
  return () =>
    Object.entries(handlers).forEach(([event, handler]) =>
      emitter.off(event, handler)
    );
};

// whatsapp-calling-ownership.UI.2 — the status menu asks the app-root call
// layer to open the Pass the line dialog (the dropdown unmounts on close).
export const OPEN_PASS_LINE_EVENT = 'kaption-call-open-pass-line';
